import { normalizeJourneyData } from './actionItemModel';

const STATUS_LINE_PATTERN = /^Status:\s*(active|completed|deferred)\s*$/i;

const replaceStatusLine = (value, status) => {
  if (typeof value !== 'string') {
    return value;
  }

  const lines = value.split('\n');
  const statusLineIndex = lines.findIndex((line) => STATUS_LINE_PATTERN.test(line.trim()));
  if (statusLineIndex < 0) {
    return value;
  }

  const nextLines = [...lines];
  nextLines[statusLineIndex] = `Status: ${status}`;
  return nextLines.join('\n');
};

export const updateActionItemStatusInDocs = (userDocs, { listroot, keyID, status }) => {
  const normalized = normalizeJourneyData(userDocs);
  const steps = normalized.steps.map((step, stepIndex) => {
    if (stepIndex !== listroot) {
      return step;
    }

    return {
      ...step,
      items: step.items.map((item) => {
        if (item.keyID !== keyID) {
          return item;
        }

        return {
          ...item,
          status,
          journeyBotStatus: status,
          value: replaceStatusLine(item.value, status),
        };
      }),
    };
  });

  return {
    ...normalized,
    steps,
  };
};
